<!-- <app-user-profile></app-user-profile> -->

<div class="pd panel mt-4" *ngIf="showForm">
    <form nz-form [formGroup]="institutionDetailForm" (ngSubmit)="submitForm()">

        <div nz-row>
            <nz-col [nzXs]="24" [nzSm]="24">
                <nz-row [nzJustify]="'space-between'">
                    <section nz-col [nzXs]="24">
                        <nz-form-item>
                            <nz-col [nzSpan]="24">
                                <nz-form-control>
                                    <nz-select nzPlaceHolder="{{'GENERAL.SELECT_COUNTRY' | translate}}" [nzCustomTemplate]="countryTemplate"
                                        formControlName="resident_country" nzPlacement="bottomLeft"
                                        [nzDisabled]="institution_detail?.resident_country"
                                        [nzShowArrow]="!institution_detail?.resident_country">
                                        <nz-option *ngFor="let country of countries" [nzValue]="country.code"
                                            [nzLabel]="country.name"></nz-option>
                                    </nz-select>

                                    <ng-template #countryTemplate let-selected>
                                        <img class="selected-country" alt="{{ selected.nzLabel }}" [src]="urls.FLAGS + selected.nzValue + '.svg'" height="20" width="20" />
                                        {{ selected.nzLabel.substring(0, 15) }}
                                    </ng-template>
                                </nz-form-control>
                            </nz-col>
                        </nz-form-item>
                    </section>

                    <section nz-col [nzXs]="24">
                        <nz-form-item>
                            <nz-col [nzSpan]="24">
                                <nz-form-control>
                                    <input nz-input name="address" formControlName="address" type="text" id="address"
                                        [readOnly]="institution_detail?.address" />
                                </nz-form-control>
                            </nz-col>
                        </nz-form-item>
                    </section>
                </nz-row>
            </nz-col>

            <nz-col [nzXs]="24" [nzSm]="24" [nzLg]="24" [nzXl]="24">
                <nz-form-item nz-row>
                    <nz-col [nzXs]="24" [nzSm]="24">
                        <nz-form-control>
                            <textarea rows="3" type="text" nz-input formControlName="description" id="description"
                                placeholder="{{'NOTIFICATIONS.DESCRIPTION' | translate}}" name="description"></textarea>
                        </nz-form-control>
                    </nz-col>
                </nz-form-item>
            </nz-col>
        </div>



        <nz-form-item>
            <nz-col nzXs="24" class="switch-wrapper">
                <nz-switch #switch formControlName="allow_public_use_of_email" [nzSize]="'small'"></nz-switch> &nbsp;

                <span class="span-left"> {{ toggleSwitchDescritpion | translate}} </span>
            </nz-col>
        </nz-form-item>

        <nz-form-item nz-row class="register-area">
            <nz-form-control [nzSm]="12" [nzXs]="12" [nzMd]="8" [nzLg]="8" [nzXl]="8" [nzXXl]="6">
                <button nz-button class="v2-btn-primary" [nzLoading]="loading" nzBlock>
                    {{'GENERAL.SUBMIT' | translate | uppercase}}
                </button>
            </nz-form-control>
            <nz-form-control [nzSm]="12" [nzXs]="12" [nzMd]="8" [nzLg]="8" [nzXl]="8" [nzXXl]="6">
                <button nz-button class="btn-clear" (click)="hideEditForm()" [nzLoading]="loading" nzBlock>
                    {{'GENERAL.CANCEL' | translate | uppercase}}
                </button>
            </nz-form-control>
        </nz-form-item>
    </form>
</div>

@if(!showForm) {
<div class="info-panel mt-4">

    <div>

        <div>
            <p class="label">{{'GENERAL.COUNTRY_OF_RESIDENCE' | translate}}</p>
            @if(!loading) {

            <p class="value items-center"><img class="selected-country mr-1"
                    alt="{{ institution_detail.resident_country }}" [src]="urls.FLAGS + institution_detail.resident_country + '.svg'" height="20" width="20" />{{institution_detail?.resident_country}}
            </p>
            } @else {
            <nz-skeleton [nzTitle]="false" [nzParagraph]="{rows: 1}" [nzActive]="true"></nz-skeleton>

            }

        </div>

        <div>
            <p class="label">{{'PROFILE.INSTITUTION-DETAIL.ADDRESS' | translate}}</p>
            @if(!loading) {
            <p class="value">{{institution_detail?.address}}</p>
            } @else {
            <nz-skeleton [nzTitle]="false" [nzParagraph]="{rows: 1}" [nzActive]="true"></nz-skeleton>
            }
        </div>

        <div>
            <p class="label">{{'PROFILE.INSTITUTION-DETAIL.DESCRIPTION' | translate}}</p>
            @if(!loading) {
            <p class="value">{{institution_detail?.description || '-'}}</p>
            } @else {
            <nz-skeleton [nzTitle]="false" [nzParagraph]="{rows: 1}" [nzActive]="true"></nz-skeleton>
            }
        </div>
    </div>

    <div>
        @if(!loading) {

        <button (click)="showEditForm()" class="btn-clear">
            <img [src]="urls?.EDIT" alt="">
            <span>{{'GENERAL.EDIT_INFO' | translate}}</span>
        </button>
        }
    </div>

</div>
}